import styled from 'styled-components';

const ShareStyle = styled.div`
	--padRightShare: var(--sp3-5x);
	--distanceShare: var(--sp2x);
	--iconWH: var(--sp9x);

	display: flex;
	flex-direction: column;
	align-items: end;
	gap: var(--distanceShare);

	.link-item {
		width: var(--iconWH);
		height: var(--iconWH);
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background-color: var(--green1000);
		color: var(--yellow1000);

		i {
			will-change: transform;
			transition: transform var(--trTime) ease-out;
		}
	}

	.media-share {
		cursor: pointer;
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.link-item {
				&:hover {
					i {
						transform: scale(1.3);
					}
				}
			}
		}
	}

	//! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--iconWH: var(--sp8x);
	}

	//! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--iconWH: var(--sp7x);
	}

	//! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	//! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--iconWH: var(--sp6x);
	}

	//! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceShare: var(--sp1x);
		--iconWH: var(--sp5x);
	}

	//! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		.link-item {
			padding: 5px 8px;
		}
	}
`;

export default ShareStyle;
